import { render, staticRenderFns } from "./detailProcess.vue?vue&type=template&id=2320fbec&"
import script from "./detailProcess.vue?vue&type=script&lang=js&"
export * from "./detailProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports